import React from "react";

import Footer from "../../../organisms/teacher/Footer";

import HelpHero from "./HelpHero";
import HelpNavigation from "./HelpNavigation";
import HelpFaqSection from "./HelpFaqSection";
import HelpEnvironmentSection from "./HelpEnvironmentSection";
import HelpContactSection from "./HelpContactSection";
import HelpMaintenance from "./HelpMaintenance";
import common from "./common.module.scss";

const HelpPage = () => {
  return (
    <div className={common.wrapper}>
      <HelpHero />
      <div className={common.container}>
        <HelpNavigation />
        <HelpFaqSection />
        <HelpEnvironmentSection />
        <HelpContactSection />
      </div>
      <HelpMaintenance />
      <Footer />
    </div>
  );
};

export default HelpPage;
